




































import { Attribute, SearchError, SearchResponse } from '@empathybroker/tsclient-search';

import { mapActions, mapGetters } from 'vuex';

import { ConfigurationsForm, ConfigurationsSearchInput, UiCheckbox } from '../../components';

import { DomainEnum } from '../../enums';

import { SetAttributeWithUrlGuard } from '../../guards';

import { ConfigurationsFormMixin } from '../../mixins/configurations-form.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { SEARCH_CONSTS } from '../../store/search/search.consts';

export default {
  name: 'browse-configurations-form',
  mixins: [ConfigurationsFormMixin],
  components: {
    ConfigurationsForm,
    UiCheckbox,
    ConfigurationsSearchInput
  },
  computed: {
    ...mapGetters(SEARCH_CONSTS.moduleName, {
      attributes: SEARCH_CONSTS.getters.attributes
    }),
    attributeName: function (): string {
      return this.$route.params[ROUTER_CONSTS.params.attribute.name];
    },
    attribute: function (): Attribute {
      const attributeValue = this.$route.params[ROUTER_CONSTS.params.attribute.value];
      const attributeValues = this.attributes[this.attributeName];
      return SetAttributeWithUrlGuard.findAttributeById(attributeValue, (attributeValues.items || attributeValues));
    },
    loadSearchDataEnabled: function (): boolean {
      return (
        ConfigurationsFormMixin.computed.loadSearchDataEnabled.bind(this)() &&
        !!this.item.context.attributeName &&
        !!this.item.context.attributeValues.length
      );
    },
    loadPreviewDisabled: function (): boolean {
      return !!this.query;
    }
  },
  data: function () {
    return {
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.configurations[DomainEnum.BROWSE].update),
      item: {
        enabled: true,
        name: undefined,
        context: {
          attributeName: undefined,
          attributeValues: [],
          pivots: {},
          inheritance: false
        },
        ranking: {
          products: {
            elements: []
          },
          attributes: {
            elements: []
          }
        },
        facets: {
          elements: []
        }
      },
      query: undefined
    };
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      browse: SEARCH_CONSTS.actions.browse,
      search: SEARCH_CONSTS.actions.search
    }),
    onItemLoad: async function (): Promise<void> {
      if (!this.item.context.attributeName) {
        this.item.context.attributeName = this.attributeName;
      }
      if (!this.item.context.attributeValues || !this.item.context.attributeValues.length) {
        this.item.context.attributeValues = [
          {
            id: this.attribute.specificId,
            name: this.attribute.name
          }
        ];
      }
      await ConfigurationsFormMixin.methods.onItemLoad.bind(this)();
    },
    fetchSearchData: async function (): Promise<SearchResponse | SearchError> { // TODO: replace 'category' ID custom mappings by config
      if (!!this.query) {
        const attributeFilterId = ((this.attributeName === 'category') ? 'category_ids' : this.attributeName);
        return this.search({
          query: this.query,
          filters: this.searchFilters,
          pagination: this.pagination,
          params: {
            filter: `${ attributeFilterId }:${ this.attribute.id }`
          }
        });
      }
      const attributeBrowseId = ((this.attributeName === 'category') ? 'categoryId' : this.attributeName);
      return this.browse({
        idParam: { [attributeBrowseId]: this.attribute.specificId },
        filters: this.searchFilters,
        pagination: this.pagination,
        params: {
          ...this.resultsPreviewParams,
          ...this.facetsPreviewParams
        }
      });
    },
    onQueryChange: async function (query: string): Promise<void> {
      this.query = query;
      await this.loadSearchData({ resetPagination: true });
    }
  }
};

